import { createListenerMiddleware } from '@reduxjs/toolkit'

export const bannerMiddleware = createListenerMiddleware()

// Il middleware è ora vuoto - la gestione dei banner è delegata 
// ai componenti specifici per avere maggiore controllo granulare
// sui messaggi e sulla logica di business
